module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=ZM - Zambia.b6c19c35.svg";